import { render, staticRenderFns } from "./BnDeplacDetails.vue?vue&type=template&id=175090ae&"
import script from "./BnDeplacDetails.vue?vue&type=script&lang=js&"
export * from "./BnDeplacDetails.vue?vue&type=script&lang=js&"
import style0 from "./BnDeplacDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports